<template>
  <div class="d-flex">
    <b-nav
      pills
      vertical
      class="mr-2"
    >
      <b-list-group-item
        v-for="g in grupos"
        :key="g.key || g"
        v-b-tooltip.hover.right
        :active="(g.label || g) === selecionado"
        :title="g.tooltip || ''"
        @click="$emit('selecionado', g.label || g)"
      >
        {{ g.label || g }}
      </b-list-group-item>
    </b-nav>
    <div class="flex-grow-1">
      <slot />
    </div>
  </div>
</template>

<script>
export default {
  name: 'MenuLateralMitApuracao',
  props: {
    grupos: { type: Array, required: true },
    selecionado: { type: String, default: '' },
  },
}
</script>
